import { useTranslation } from "@/i18n";

const LANG_BUTTONS = [
  { id: "en", label: "EN" },
  { id: "fi", label: "FI" },
  { id: "sv", label: "SV" },
];

export default function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useTranslation();
  return (
    <div
      className={["inline-flex items-center rounded-full bg-slate-100 p-0.5", className].join(" ")}
      data-testid="language-switcher"
      role="group"
      aria-label="Language"
    >
      {LANG_BUTTONS.map((l) => {
        const active = lang === l.id;
        return (
          <button
            key={l.id}
            type="button"
            onClick={() => setLang(l.id)}
            aria-pressed={active}
            className={[
              "px-2 h-6 rounded-full text-[11px] font-semibold tracking-wide transition-colors",
              active ? "bg-white shadow text-slate-900" : "text-slate-500 hover:text-slate-900",
            ].join(" ")}
            data-testid={`lang-${l.id}`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
